<template>
  <v-card @click="showReporAbc()" :disabled="loading" outlined>
    <v-progress-linear v-show="loading" color="primary" indeterminate></v-progress-linear>
    <v-card-title>
        Curva ABC
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col></v-col>
        <v-col>
          <div style="width: 600px; position:relative ">
            <line-chart :chart-data="chartData" :options="chartOptions" />
            <div style="height:50px;width:600px;background:white;position:absolute;top:262px"> </div>
          </div>
        </v-col>
        <v-col></v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { Line } from "vue-chartjs";
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);
import { mapActions } from "vuex";
export default {
  components: { "line-chart": Line },
  data() {
    return {
      costId: null,
      loading: false,
      chartData: {
        labels: [],
        datasets: [
        //   {
        //     label: "",
        //     backgroundColor: "#000000",
        //     borderColor: "#000000",
        //     fill: false,
        //     data: [],
        //     order: 1,
        //     borderWidth: 0.1,
        //     pointRadius: 1,
        //     showLine: false,
        //   },
          {
            type: "line",
            fill: true,
            label: "A",
            data: [],
            backgroundColor: "#1976d2",
            borderColor: "#1976d2",
            order: 2,
            barPercentage: 1.0, // 1.0 = barra mais grossa
            categoryPercentage: 1.0,
            pointRadius: 0,
          },
          {
            type: "line",
            fill: true,
            label: "B",
            data: [],
            backgroundColor: "#ff5252",
            borderColor: "#ff5252",
            order: 3,
            barPercentage: 1.0, // 1.0 = barra mais grossa
            categoryPercentage: 1.0,
            pointRadius: 0,
          },
          {
            type: "line",
            fill: true,
            label: "C",
            data: [],
            backgroundColor: "#fb8c00",
            borderColor: "#fb8c00",
            order: 4,
            barPercentage: 1.0, // 1.0 = barra mais grossa
            categoryPercentage: 1.0,
            pointRadius: 0,
          },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: true,
        legend: {
          display: false, // Esconde a legenda
        },
        scales: {
          x: {
            type: "linear",
            title: {
              display: false,
              callback: () => "",
            },
            ticks: {
              display: false,
            },
            grid: {
              display: false,
            },
          },
          y: {
            // Se quiser ocultar o Y também, adicione:
            // ticks: { display: false }
          },
        },
      },
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions("Dashboard", ["getChartCurveABC"]),
    getData() {
      this.loading = true;
      this.getChartCurveABC()
        .then((response) => {
        //   this.chartData.datasets[0].data = response.data.chart_importance_acumulated;
          this.chartData.datasets[0].data = response.data.chart_importance_acumulatedA;
          this.chartData.datasets[1].data = response.data.chart_importance_acumulatedB;
          this.chartData.datasets[2].data = response.data.chart_importance_acumulatedC;
          this.chartData.labels = response.data.chart_ids;
          this.costId = response.data.cost_id;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showReporAbc() {
      this.$router.push({ path: "/system/report/input/abc/inputs/" + this.costId });
    },
  },
};
</script>
